import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Axios from "axios-observable";
import { throwError } from "rxjs";
import { BASE_API_URL } from "../config";
import { store } from "./../index";
import { logout } from "./../store/modules/user/actions";

export const http = Axios.create({
  baseURL: `${BASE_API_URL}/v1`,
  responseType: "json",
});

http.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { headers } = config;
    const {
      user: { authToken },
    } = store.getState();

    return authToken
      ? {
          ...config,
          headers: {
            ...headers,
            Authorization: `Bearer ${authToken}`,
          },
        }
      : config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      // Ignore Login
      if (error?.response.config.url !== "/token/") {
        store.dispatch(logout());
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export function messageError(error: any, message: string) {
  const { response } = error;
  if (response && response.status === 500) {
    return throwError(
      "We are experiencing issues with our system. Please try again later or contact support at support@due.com ."
    );
  } else if (response && response.data && response.data.detail) {
    return throwError(response.data.detail);
  } else if (response && response.data && response.data.message) {
    return throwError(response.data.message);
  } else {
    return throwError(message);
  }
}
